export const SET_AUTHENTICATED_USER = 'setAuthenticatedUser';
export const DELETE_AUTHENTICATED_USER = 'deleteAuthenticatedUser';
export const LOAD_AUTHENTICATED_USER = 'loadAuthenticatedUser';
